import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import MovableExcavator from './MovableExcavator';
import SEOHelmet from '../../components/SEO/SEOHelmet';


// Breadcrumbs Background Image

const Peak = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <SEOHelmet 
                title="Movable Excavator for Scrap Processing"
                description="Mobile excavator solution for scrap material handling and processing. Flexible, efficient, and cost-effective for steel mills and recycling facilities."
                keywords="movable excavator, mobile excavator, scrap processing, material handling, excavator rental"
                canonicalUrl="https://ramanasteels.com/movable-excavator"
            />
            <Header
                navImg={navImg1}
                parentMenu='peak-performance-roofing'
                activeMenu="/peak-performance-roofing"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="Movable Excavator"
                pageName="Movable Excavator"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <MovableExcavator />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default Peak;